// Using dynamic import to work in modern bundlers
export default function snapSvgImporter() {
  try {
    // For Vite/modern bundlers, we need to get Snap from the window object
    // after the script has been loaded via ESM/dynamic import
    return window.Snap || null;
  } catch (error) {
    console.error('Could not load Snap SVG:', error);
    return null;
  }
}
